export default {
  getSearchValue(state) {
    return state.searchValue
  },
  getInstantSearchOpened(state) {
    return state.opened
  }
}
